import React from 'react';
import Slider from 'react-slick';

interface ContainerExample {
    imageUrl: string;
    alt?: string;
    location: string;
    quote: string;
}

interface ContainerExamplesProps {
    examples: ContainerExample[];
    title: string;
    subtitle: string;
    text: string;
    bgColor?: 'white' | 'sand';
}

const ContainerExamples: React.FC<ContainerExamplesProps> = ({ examples, title, subtitle, text, bgColor }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 2,
        arrows: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
        ]
    };
    const bgClass = bgColor === 'sand' ? 'bg-productCard' : 'bg-white';

    return (
        <section className={`py-16 px-4 ${bgClass}`}>
            <div className="max-w-6xl mx-auto">
                {title && (
                    <h2 className="text-3xl font-bold text-center text-textColor mb-6">{title}</h2>
                )}

                {subtitle && (
                    <h2 className="text-2xl font-semibold text-center text-textColor mb-6">{subtitle}</h2>
                )}

                <p className="text-gray-700 text-lg mb-6">{text}</p>

                <div className="md:px-8">
                    <Slider {...settings}>
                        {examples.map((ex, idx) => (
                            <div
                                key={idx}
                                className="bg-white h-[22.5rem] rounded-xl shadow overflow-hidden border border-lineGreen/30 gap-8"
                            >
                                <img
                                    src={ex.imageUrl}
                                    alt={ex.alt || `Container in ${ex.location}`}
                                    loading="lazy"
                                    className="w-full h-48 object-cover"
                                />
                                <div className="p-5 flex flex-col gap-2">
                                    <h3 className="text-lg font-bold text-textColor">{ex.location}</h3>
                                    <p className="text-sm text-gray-600">{ex.quote}</p>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default ContainerExamples;
